const windowCopy = window;

export { windowCopy as window }